// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

export default class Livestream extends Component<Props> {
    componentDidMount() {
        const { embed_id } = this.props.content;
        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts) loadScripts(customScripts);
        else {
            const script = document.createElement('script');

            script.src = `//livestream.com/assets/plugins/referrer_tracking.js`;
            script.id = `livestream-script`;
            script.dataset.embedId = embed_id;
            if (document.body) {
                document.body.appendChild(script);
            }
        }
    }

    componentWillUnmount() {
        const script = document.getElementById('livestream-script');
        if (script) {
            script.outerHTML = '';
        }
    }

    render() {
        if (this.props.content === '') return null;

        const { embed_id, account_id, event_id, video_id } = this.props.content;

        return (
            <iframe
                id={`ls_embed_${embed_id}`}
                src={`//livestream.com/accounts/${account_id}/events/${event_id}/videos/${video_id}/player?width=750&height=420&enableInfoAndActivity=true&autoPlay=true&mute=false`}
                width="750"
                height="420"
                frameBorder="0"
                scrolling="no"
                allowFullScreen={true}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Livestream.js